import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tokenId: null,
    initialized: false,
    translations: {},
    config: {}
  },
  mutations: {
    setTokenId(state, tokenId) {
      state.tokenId = tokenId
    },
    updateSkill(state, skill) {
      state.skills[skill.id] = Object.assign(state.skills[skill.id] || {}, skill);
      state.translations = Object.assign(state.translations, skill.translations);
    },
    setConfig(state, data) {
      state.config = data;
    },
    setServices(state, data) {
      state.services = {};
      Object.values(data.services).forEach(element => {
        state.services[element.id] = element;
      });
      state.skills = {};
      Object.values(data.skills).forEach(element => {
        state.skills[element.id] = element;
      });
      state.jobs = {};
      Object.values(data.jobs).forEach(element => {
        state.jobs[element.id] = element;
      });
      state.labels = [];
      Object.values(data.labels).forEach(element => {
        state.labels.push(element);
      });
      state.labels = state.labels.sort((l1, l2) => {
        return l2.priority - l1.priority;
      });
      // console.log(state.labels);
    },
    setUsers(state, users) {
      state.users = {};
      users.forEach(user => {
        state.users[user.id] = user;
      });
    },
    setOrders(state, orders) {
      state.orders = {};
      orders.forEach(order => {
        state.orders[order.id] = order;
      });
    },
    setInitialized(state, status) {
      state.initialized = status;
    },
  },
  actions: {

  }
})
